"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandMapper = void 0;
const lodash_1 = __importDefault(require("lodash"));
class BrandMapper {
    toDomain(result) {
        const id = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.id");
        const importationType = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.importationType");
        const brand = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.brand");
        const externalServices = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.externalServices");
        const enabledPreferredZones = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.enabledPreferredZones");
        const maximumPreferredZones = lodash_1.default.get(result, "data.getUser.currentHoldingView.holding.maximumPreferredZones");
        let preferredZones = lodash_1.default.get(result, "data.getUser.currentHoldingView.preferredZones") || [];
        preferredZones = preferredZones.map((eachPreferredZone) => ({
            id: eachPreferredZone.id,
            name: eachPreferredZone.name
        })).sort((zoneA, zoneB) => {
            if (zoneA.name < zoneB.name) {
                return -1;
            }
            if (zoneA.name > zoneB.name) {
                return 1;
            }
            return 0;
        });
        return {
            id,
            brand,
            externalServices,
            importationType,
            enabledPreferredZones,
            maximumPreferredZones,
            preferredZones
        };
    }
}
exports.BrandMapper = BrandMapper;
